import React, {Component} from 'react';
import PropTypes from 'prop-types';

import MobileNavigationBar from './MobileNavigationBar'
import styles from './MobileNavigationBarContainer.scss';


import classnames from 'classnames';


/**
 * Aside container for mobile header. It is just a dark wrap with required props.
 */
export default class MobileNavigationBarContainer extends Component {
    static propTypes = {
        className: PropTypes.string,
        show: PropTypes.bool, //use this to handle show state outside
        role: PropTypes.object.isRequired, //required to know what links should be rendered
        onHide: PropTypes.func, //onHide callback
        onShowRegistration: PropTypes.func,
        onShowLogin: PropTypes.func,
        onHideRegistration: PropTypes.func,
        onHideLogin: PropTypes.func,
        onLogout: PropTypes.func,
        onShowForgotPassword: PropTypes.func,
        onHideForgotPassword: PropTypes.func,
        isSelfHandled: PropTypes.bool //need to handle close by element or outside by props (default == false)
    };

    constructor(props) {
        super(props);

        this.state = {
            show: props.show
        };
    }

    state = {
        show: false
    };

    show() {
        this.setState({
            show: true
        })
    }

    hide() {
        if (this.props.isSelfHandled) {
            this.setState({
                show: false
            }, this.props.onHide);
        } else {
            this.props.onHide();
        }
    }

    toggleShow() {
        this.setState({
            show: !this.state.show
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.show != this.props.show) {
            this.setState({
                show: nextProps.show
            })
        }
    }


    render() {
        const {children, className} = this.props;
        const {show} = this.state;

        const navStyles = classnames(styles.mobileNavBarContainer,
            className ? className : '',
            show ? styles.show : styles.hide
        );

        const props = {
            ...this.props,
            show,
            onHide: ::this.hide
        };
        return (
            <div className={navStyles}>
                <MobileNavigationBar {...props}>
                    {children}
                </MobileNavigationBar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/Mobile/MobileNavigationBarContainer.js